import gql from 'graphql-tag';
import { Conversation } from 'graphModels/conversation';

export const FETCH_CONVERSATION = gql`
  query ($conversationId: Int!) {
    conversation( conversationId: $conversationId ) {
      ${ Conversation }
    }
  }
`;
